import React from 'react'
import { About, CallToAction, ContactUs, DisabilityServices, Hero, PersonalizedCare, Services } from '../../components'

import './home.css'

const Home = () => {
  return (
    <>
      <div className='home-wrapper'>
        <Hero />
        <About />
        <Services />
        <PersonalizedCare />
        <CallToAction />
        <DisabilityServices />
        <ContactUs />
      </div>
    </>
  )
}

export default Home